import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colour", "position", "bandCount", "icon", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.big.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { alpha } from 'utils/ui/colors';
import Icon from 'components/Icon';
import { Disc, Wrapper } from 'components/IconDisc';
import { scalePresets } from 'components/CircleImage';
import { RING_WIDTH } from 'components/PercentageDisc';
import { jsx as _jsx } from "react/jsx-runtime";
var Ring = styled(Disc).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['colour', 'filled'].includes(prop);
  }
}).withConfig({
  displayName: "ScoreBandDonut__Ring",
  componentId: "sc-1pbcszg-0"
})(["background:conic-gradient( ", " 0 ", "%,", " ", "% 100% );"], function (p) {
  return p.colour;
}, function (p) {
  return p.filled;
}, function (p) {
  return alpha(p.theme.text, 0.2);
}, function (p) {
  return p.filled;
});
var Hole = styled.span.withConfig({
  displayName: "ScoreBandDonut__Hole",
  componentId: "sc-1pbcszg-1"
})(["display:flex;align-items:center;justify-content:center;width:calc(100% - 2 * ", ");height:calc(100% - 2 * ", ");border-radius:100%;background:linear-gradient( ", ",", " ),", ";"], RING_WIDTH, RING_WIDTH, function (p) {
  return alpha(p.theme.shade, p.theme.shadeStrength);
}, function (p) {
  return alpha(p.theme.shade, p.theme.shadeStrength);
}, function (p) {
  return p.theme.background;
});
/**
 * Shows which score band a score is in without showing the score: a ring filled to the band's
 * share of the bands, in the band's colour. Meant to sit alongside the band's name (see
 * `ScoreBandPill`), so it is hidden from screen readers.
 */
var ScoreBandDonut = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var colour = _ref.colour,
    position = _ref.position,
    bandCount = _ref.bandCount,
    icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'big' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var filled = bandCount > 0 ? Math.min(100, Math.max(0, position / bandCount * 100)) : 0;
  var isBig = size === 'big';
  return /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({
    ref: ref,
    "aria-hidden": "true"
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsx(Ring, _objectSpread(_objectSpread({}, scalePresets.big), {}, {
      scale: isBig ? 2 : 1,
      colour: colour,
      filled: filled,
      children: /*#__PURE__*/_jsx(Hole, {
        children: /*#__PURE__*/_jsx(Icon, {
          name: icon,
          "data-iconname": icon
        })
      })
    }))
  }));
});
ScoreBandDonut.displayName = 'ScoreBandDonut';
export default ScoreBandDonut;